import { z } from 'zod';
import { isoDateSchema, timestampedSchema, uuidSchema } from './common';

export const passKindSchema = z.enum([
  'class_card',
  'intro_pass',
  'unlimited_membership',
  'lesson_pack',
]);
export type PassKind = z.infer<typeof passKindSchema>;

export const passProductInputSchema = z.object({
  name: z.string().trim().min(1).max(140),
  kind: passKindSchema,
  program_id: uuidSchema.optional(),
  included_uses: z.number().int().positive().optional(),
  valid_days: z.number().int().positive().optional(),
  price_cents: z.number().int().nonnegative(),
  active: z.boolean().default(true),
  notes: z.string().trim().max(3000).optional(),
});
export type PassProductInput = z.input<typeof passProductInputSchema>;

export const passProductSchema = timestampedSchema.extend({
  name: z.string(),
  kind: passKindSchema,
  program_id: uuidSchema.nullable(),
  included_uses: z.number().int().positive().nullable(),
  valid_days: z.number().int().positive().nullable(),
  price_cents: z.number().int().nonnegative(),
  active: z.boolean(),
  notes: z.string().nullable(),
});
export type PassProduct = z.infer<typeof passProductSchema>;

export const familyPassBalanceInputSchema = z.object({
  family_id: uuidSchema,
  pass_product_id: uuidSchema,
  purchased_charge_id: uuidSchema.optional(),
  remaining_uses: z.number().int().nonnegative().optional(),
  valid_from: isoDateSchema.optional(),
  valid_until: isoDateSchema.optional(),
  active: z.boolean().default(true),
  notes: z.string().trim().max(3000).optional(),
});
export type FamilyPassBalanceInput = z.input<typeof familyPassBalanceInputSchema>;

export const familyPassBalanceSchema = timestampedSchema.extend({
  family_id: uuidSchema,
  pass_product_id: uuidSchema,
  purchased_charge_id: uuidSchema.nullable(),
  remaining_uses: z.number().int().nonnegative().nullable(),
  valid_from: isoDateSchema,
  valid_until: isoDateSchema.nullable(),
  active: z.boolean(),
  notes: z.string().nullable(),
});
export type FamilyPassBalance = z.infer<typeof familyPassBalanceSchema>;
